import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';
import { motion } from 'framer-motion';
export function BeforeAfterSection() {
  const {
    t
  } = useLanguage();
  const cases = [{
    id: 4,
    image: 'https://cdn.magicpatterns.com/uploads/vsFTrnUQh7uz7txA1x4vSh/BF2.jpg',
    alt: 'Before & After - Singderm Filler Case'
  }, {
    id: 5,
    image: 'https://cdn.magicpatterns.com/uploads/h59Cejq27kiX3EWYjQShsb/S__42106908_0.jpg',
    alt: 'Before & After - Singderm Filler Case 2'
  }, {
    id: 6,
    image: 'https://cdn.magicpatterns.com/uploads/nPC1qsuorW32oe1nh3R99R/S__42106909_0.jpg',
    alt: 'Before & After - Singderm Filler Case 3'
  }];
  return <section id="before-after" className="py-24 bg-brand-bg" data-id="element-55">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-56">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-57">
          <h2 className="text-sm font-bold tracking-widest text-brand-copper uppercase mb-3" data-id="element-58">
            {t('beforeAfter.label')}
          </h2>
          <h3 className="text-3xl md:text-4xl font-light text-gray-900 mb-6" data-id="element-59">
            {t('beforeAfter.title1')}{' '}
            <span className="font-semibold" data-id="element-60">{t('beforeAfter.title2')}</span>
          </h3>
          <p className="text-gray-600" data-id="element-61">{t('beforeAfter.subtitle')}</p>
        </div>

        {/* Cases Gallery */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-6xl mx-auto" data-id="element-62">
          {cases.map((item, index) => <motion.div key={item.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.15
        }} className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden" data-id="element-63">
              <div className="aspect-[3/4] overflow-hidden" data-id="element-64">
                <img src={item.image} alt={item.alt} className="w-full h-full object-cover hover:scale-105 transition-transform duration-500" data-id="element-65" />
              </div>
              <div className="p-4 flex justify-center gap-4" data-id="element-66">
                <span className="bg-gray-100 text-gray-600 px-3 py-1 rounded text-xs font-semibold tracking-wider" data-id="element-67">
                  {t('beforeAfter.before')}
                </span>
                <span className="bg-brand-copper text-white px-3 py-1 rounded text-xs font-semibold tracking-wider" data-id="element-68">
                  {t('beforeAfter.after')}
                </span>
              </div>
            </motion.div>)}
        </div>

        <div className="mt-12 text-center" data-id="element-69">
          <p className="text-sm text-gray-500 italic" data-id="element-70">
            {t('beforeAfter.disclaimer')}
          </p>
        </div>
      </div>
    </section>;
}